import type { EditionButtonReturn } from '@ingenico/react-section-utils';
import type { KebabMenuOption } from '@ingenico/react-ui/kebab-menu';
import type { TabSection } from '@ingenico/react-ui/tabs-view';
import type {
  GridCallbackDetails,
  GridColDef,
  GridPaginationModel,
  GridSortModel,
  GridApiPremium,
} from '@mui/x-data-grid-premium';
import type { TFunction } from 'i18next';
import type { MutableRefObject, ReactNode } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import type { OverViewPayloadDTO } from '../../components/overview-tab/Overviewtab.model';
import type {
  MappedSystemPackageVersionResourceListResponseV2Api,
  SystemPackageResource,
} from '../../domain/models/systemPackage.model';
import type { VersionQuickFilter } from '../../hooks/useVersionQuickFilter.hook';

export enum SystemPackageDetailsPageTabs {
  OVERVIEW = 'OVERVIEW',
  VERSIONS = 'VERSIONS',
  ORGANIZATIONS = 'ORGANIZATIONS',
}

export interface SystemPackageVersionsTabColumns {
  readonly columns: GridColDef[];
  readonly defaultAvailableColumns: string[];
}

export enum VersionStatus {
  PUBLISHED = 'published',
  DEPRECATED = 'deprecated',
}

export interface OSVersion {
  readonly name: string;
  readonly version: string;
}

export interface SystemPackageDetailsPageVMOutput {
  readonly details: Partial<OverViewPayloadDTO>;
  readonly selectedTabIndex: number;
  readonly tabs: TabSection[];
  readonly isFetching: boolean;
  readonly isError: boolean;
  readonly deprecateOrRestoreConfirmationComponentChildren: ReactNode;
  readonly kebabValues: KebabMenuOption[];
}

export interface UseGetSystemPackageDetailsTabsProps {
  readonly details: Partial<OverViewPayloadDTO>;
  readonly editButton: EditionButtonReturn;
  readonly form: UseFormReturn<SystemPackageResource>;
  readonly handleAddNewVersionClick: () => void;
  readonly isAddVersionButtonVisible: boolean;
  readonly shouldRenderOrganizationsTab: boolean;
  readonly isEditButtonsVisible: boolean;
  readonly systemPackageId?: string;
}

export interface IUseSystemPackageDetailsPageVM {
  readonly t: TFunction;
}

export interface SystemPackageVersionsListResponse {
  readonly isLoading: boolean;
  readonly isFetching: boolean;
  readonly data: MappedSystemPackageVersionResourceListResponseV2Api;
  readonly error?: unknown;
  readonly isSuccess?: boolean;
  readonly isError?: boolean;
}

export interface SearchData {
  readonly handleSearchQueryChange: (v: string) => void;
  readonly searchQuery: string;
}

export interface SystemPackageVersionsGridProps {
  readonly ref: MutableRefObject<GridApiPremium>;
  readonly total: number;
  readonly handlePaginationModelChange: (
    model: GridPaginationModel,
    details: GridCallbackDetails<'pagination'>,
  ) => void;
  readonly handleSortModelChange: (sort: GridSortModel, details: GridCallbackDetails) => void;
}
export interface UseGetSystemPackageVersionResponse {
  readonly search: SearchData;
  readonly gridProps: SystemPackageVersionsGridProps;
  readonly quickFiltersSearch: VersionQuickFilter;
  readonly response: SystemPackageVersionsListResponse;
  readonly shouldDisplayGrid: boolean;
}
